// src/utils/dateFormatter.js

/**
 * Formata uma data para dd/MM/yyyy (ex: "19/03/2026").
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/**
 * Formata uma data com hora para dd/MM/yyyy HH:mm (ex: "19/03/2026 14:30").
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

/**
 * Formata uma data por extenso (ex: "19 de março de 2026").
 * Aceita string de data no formato "yyyy-MM-dd" (sem horário).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateLong(value) {
  if (!value) return '';
  const raw = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? value + 'T00:00:00'
    : value;
  const d = new Date(raw);
  if (isNaN(d.getTime())) return typeof value === 'string' ? value : '';
  return d.toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/**
 * Formata uma data curta (ex: "19 de mar. de 2026").
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateShort(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Formata apenas o horário HH:mm (ex: "14:30").
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}
